/* eslint-disable */
import { mapGetters , mapMutations } from 'vuex'
import Themes from '@/plugins/theme.js'

import UserApi from '@/api/identityProvider/user'
import EnterKeyPress from '@/directives/enter-key-press'

export default {
    data () {
        return {
            formUniqueCode: "",
            privilegeUniqueCode: "",
            showItem:{ },
            themes: Themes, 
            searchDateTime: null,
            dataFooter:{
                "items-per-page-text": this.recordsPerPage,
                "items-per-page-all-text": this.recordPerPageAllText,
                "page-text": this.pageText,
                "show-current-page": true,
                "show-first-last-page": true
            },              
        }
    },    
    directives: {
        "enter-key-press": EnterKeyPress
    },    
    computed: {  
        ...mapGetters("app", ["getLoaderQueue", "getIsAuthenticated"]),
        getSearchDateAndTime(){
            if(this.searchDateTime == null) return null;

            let text = this.$t("Common.search-time");
            text = text.replace("{0}", this.searchDateTime);
            return text;
        },  
        back () {
            return this.$t('Common.back');
        },   
        save () {
            return this.$t('Common.save');
        },               
        confirm () {
            return this.$t('Common.confirm');
        },  
        cancel () {
            return this.$t('Common.cancel');
        },     
        search () {
            return this.$t('Common.search');
        },             
        clear () {
            return this.$t('Common.clear');
        },        
        close () {
            return this.$t('Common.close');
        },              
        recordsPerPage () {
            return this.$t("Common.items-per-page-text");
        },       
        recordPerPageAllText () {
            return this.$t("Common.items-per-page-all-text");
        },       
        pageText () {
            return this.$t("Common.page-text");
        },           
        processing () {
            return this.$t("Common.processing");
        },   
        loading () {
            return this.$t("Common.loading");
        },
        yes () {
            return this.$t("Common.yes");
        },
        no () {
            return this.$t("Common.no");
        },
        add () {
            return this.$t("Common.add");
        },      
        isAuthenticated(){
            return this.getIsAuthenticated;
        }  
    }, 
    async mounted(){
        this.dataTableFooter();
        this.searchDateTime = null;

        if(this.$_.trim(this.formUniqueCode) != "" && this.$_.trim(this.privilegeUniqueCode)){
            const guid = `${this.guid()}-${new Date().getTime()}`;

            this.setLoaderText(this.$t("Common.check-form-permission"));
            this.setLoaderQueue(guid);  
            
            const granted = await UserApi.hasAccess(this.$_.trim(this.formUniqueCode), this.$_.trim(this.privilegeUniqueCode)).catch(
                () => this.$router.push("/acesso-negado")             
            );
            
            this.unsetLoaderQueue(guid);
            if(!granted.success || !granted.data)
                this.$router.push("/acesso-negado");                    
        }
    },       
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
    },
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },     
    methods: {
        ...mapMutations("app", ["setMessageBox", "setConfirmDialog", "setSnackbar", "setErrors", "setLoaderText", "setLoaderShow", "setLoaderQueue", "unsetLoaderQueue", "clearLoaderQueue"]),
        async hasAccess(objectUniqueCode, privilegeUniqueCode){ 
            let returnValue = false;       
            const granted = await UserApi.hasAccess(objectUniqueCode, privilegeUniqueCode);

            if(granted.success && granted.data)
                returnValue = true;       
                
            return returnValue;
        },  
        setLocale(){
            this.$set(this.dataFooter, "items-per-page-text", this.recordsPerPage);
            this.$set(this.dataFooter, "items-per-page-all-text", this.recordPerPageAllText);
            this.$set(this.dataFooter, "page-text", this.pageText);
        },           
        sortDataTable(items, index, isDescending) {
            let sort = this.$_.sortBy(items, index);

            if (isDescending.length > 1 && isDescending[1]) sort = this.$_.reverse(sort);
            return sort;
        },              
        guid(){        
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
              );
        },               
        showPendency(description){
            this.clearLoaderQueue();
            let snackbar = this.$_.clone(this.$store.state.app.snackbar);

            snackbar.enabled = true;
            snackbar.type = "warning";
            
            snackbar.timeout = 12000;
            snackbar.title = this.$t("Common.mandatory-field");

            snackbar.description = description;
            this.setSnackbar(snackbar);
        }, 
        showSnackbarError(error){
            let message = "";
            this.clearLoaderQueue();

            for(let i = 0; i < error.length; i++)
                message += `${error[i].userMessage}<br/>`;
                
            let snackbar = this.$_.clone(this.$store.state.app.snackbar);
            snackbar.enabled = true;

            snackbar.type = "error";
            snackbar.timeout = 60000;

            snackbar.title = error[0].userTitle;
            snackbar.description = message;

            this.setSnackbar(snackbar);
        },   
        showMessage(title, text, callback){
            this.clearLoaderQueue();

            let messageBox = this.$_.clone(this.$store.state.app.messageBox);
            messageBox.title = title;

            messageBox.text = text;
            if(callback != undefined && callback != null) 
                messageBox.callback = callback;

            messageBox.show = true;
            this.setMessageBox(messageBox);
        },
        showError(title, error){
            this.clearLoaderQueue();

            let errorMessageBox = this.$_.clone(this.$store.state.app.errorMessageBox);
            errorMessageBox.show = false;

            errorMessageBox.error = error;
            this.setErrors(errorMessageBox); 
        },                      
        showConfirmDialog(title, text, confirmCallBack, closeCallback){
            this.clearLoaderQueue();

            let confirmDialog = this.$_.clone(this.$store.state.app.confirmDialog);
            confirmDialog.show = true;

            confirmDialog.title = title;
            confirmDialog.text = text;

            confirmDialog.closeCallback = closeCallback;
            confirmDialog.confirmCallback = confirmCallBack;
            
            this.setConfirmDialog(confirmDialog); 
        }, 
        showLoading(){
            const self = this;
            const guid = `${this.guid()}-${new Date().getTime()}`;

            self.setLoaderText(self.loading);
            self.setLoaderQueue(guid);    
            
            return { guid: guid, close: () => self.unsetLoaderQueue(guid) };
        },     
        showProcessing(){
            const self = this;
            const guid = `${this.guid()}-${new Date().getTime()}`;

            self.setLoaderText(self.processing);
            self.setLoaderQueue(guid);

            return { guid: guid, close: () => self.unsetLoaderQueue(guid) };
        },         
        createListYesOrNo(){
            return [
                { id: 1, value: this.yes},
                { id: 0, value: this.no}
            ]; 
        },                                 
        dataTableFooter(){
            this.$set(this.dataFooter, "items-per-page-text", this.recordsPerPage);
            this.$set(this.dataFooter, "items-per-page-all-text", this.recordPerPageAllText);
            this.$set(this.dataFooter, "page-text", this.pageText);
        },
        historyBack(){
            this.$router.go(-1);
        }            
    }
}